<div class="control" [ngClass]="control.propertyBinding">
  @switch (control.controlType) {
    @case (ControlType.INPUT) {
      @if (control.customOptions?.isDisplayonly) {
        <div class="display-only__label">{{ control.label }}</div>
        <div class="display-only__content">
          {{ control.formControls[0].formControl.value }}
        </div>
      } @else {
        <lib-text-box-control [control]="control"></lib-text-box-control>
      }
    }
    @case (ControlType.READONLY) {
      <lib-text-box-control
        [control]="control"
        [isReadonly]="true"
      ></lib-text-box-control>
    }
    @case (ControlType.MULTISELECT) {
      <lib-multi-select-control [control]="control"></lib-multi-select-control>
    }
    @case (ControlType.DATE) {
      <lib-date-picker-control [control]="control"></lib-date-picker-control>
    }
    @case (ControlType.DATERANGE) {
      <lib-date-range-control [control]="control"></lib-date-range-control>
    }
    @case (ControlType.PILL) {
      <lib-pill-button-group [control]="control"> </lib-pill-button-group>
    }
    @case (ControlType.CLIMATE_ZONE) {
      <lib-climate-zone [control]="control"></lib-climate-zone>
    }
    @case (ControlType.TOGGLE) {
      <mat-slide-toggle
        [ngClass]="control.formControls[0].formControl.invalid ? 'invalid' : ''"
        [formControl]="control.formControls[0].formControl"
        color="primary"
        ><mat-label>{{ control.label }}</mat-label></mat-slide-toggle
      >
    }
    @case (ControlType.CHECKBOX) {
      <mat-checkbox [formControl]="control.formControls[0].formControl"
        ><mat-label>{{ control.label }}</mat-label>
      </mat-checkbox>
    }
    @case (ControlType.INCREMENTING) {
      <div class="incrementing-label">
        <mat-label>{{ control.label }}</mat-label>
        <input matInput [formControl]="control.formControls[0].formControl" />
      </div>
    }
    @case (ControlType.SELECT) {
      <lib-select-control [control]="control"></lib-select-control>
    }
    @case (ControlType.LABEL) {
      <mat-label>{{ control.label }}</mat-label>
    }
    @case (ControlType.ACTION_BUTTON) {
      <mat-label>{{ control.label }}</mat-label>
      <button
        type="button"
        mat-flat-button
        color="primary"
        (click)="handleControl(control.propertyBinding)"
      >
        {{ control.customOptions.actionButtonLabel }}
      </button>
    }
    @case (ControlType.DESIGN_LABEL) {
      <mat-label class="design-label">{{ control.label }}</mat-label>
      @if (control.warningTooltip) {
        <mat-icon class="warning-tooltip" [matTooltip]="control.warningTooltip"
          >warning</mat-icon
        >
      }
    }
    @case (ControlType.LABELED_INCREMENTING) {
      <div class="labeled-incrementing">
        <div class="design-label-row">
          <mat-label class="design-label">{{ control.label }}</mat-label>
          @if (control.warningTooltip) {
            <mat-icon class="warning-tooltip" [matTooltip]="control.warningTooltip"
              >warning</mat-icon
            >
          }
        </div>
        <div class="incrementing-label">
          <mat-label>{{ control.customOptions?.incrementingLabel }}</mat-label>
          <input matInput [formControl]="control.formControls[1].formControl" />
        </div>
      </div>
    }
    @case (ControlType.CUST_INPUT) {
      <lib-customer-input-control
        [custControl]="control"
      ></lib-customer-input-control>
    }
    @case (ControlType.STATE_SELECT) {
      <mat-form-field>
        <mat-label>{{ control.label }}</mat-label>
        <mat-select [formControl]="control.formControls[0].formControl">
          @for (option of stateValues; track option) {
            <mat-option [value]="option.StateCode">{{
              option.Name
            }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @case (ControlType.SBRA_DROPDOWN) {
      <lib-sbra-dropdown-control
        [control]="control"
      ></lib-sbra-dropdown-control>
    }
    @case (ControlType.TEXTAREA) {
      @if (control.customOptions?.fullWidth) {
        <lib-text-area-control
          [control]="control"
          [resizeDisabled]="true"
        ></lib-text-area-control>
      } @else {
        <lib-text-area-control [control]="control"></lib-text-area-control>
      }
    }
    @case (ControlType.TEXT) {
      <p style="float: left">{{ control.formControls[0].formControl.value }}</p>
      @if (control.customOptions.tooltip) {
        <mat-icon
          style="float: left"
          [matTooltip]="control.customOptions.tooltip"
          color="primary"
          >info</mat-icon
        >
      }
    }
    @case (ControlType.BANNER) {
      <lib-banner
        [message]="
          control.formControls?.[0]?.formControl?.value || control.label || ''
        "
      ></lib-banner>
    }
    @default {
      Control not defined.
    }
  }
  @if (control.tooltip && !control.tooltipHidden) {
    <mat-icon [matTooltip]="control.tooltip" color="primary">info</mat-icon>
  }
  @if (control.errorMessage) {
    <mat-error>{{ control.errorMessage }}</mat-error>
  }
  @if (control.warningMessage) {
    <mat-error class="warning">{{ control.warningMessage }}</mat-error>
  }
</div>
